/**
 * Superadmin granular permissions system.
 *
 * Rules:
 *   permissions === null | undefined | [] → god admin (full access)
 *   permissions === ["whatsapp", "tickets"] → access ONLY to those modules
 */

export const PERMISSION_MODULES = {
  dashboard:          { label: 'Dashboard',          description: 'Panel principal superadmin' },
  negocios:           { label: 'Negocios',           description: 'Gestión de negocios' },
  banners:            { label: 'Banners',            description: 'Gestión de banners' },
  landing:            { label: 'Landing',            description: 'Layout del landing page' },
  tickets:            { label: 'Tickets',            description: 'Tickets de soporte' },
  categorias:         { label: 'Categorías',         description: 'Categorías del marketplace' },
  tipos_negocio:      { label: 'Tipos de Negocio',   description: 'Catálogo de tipos de negocio' },
  categorias_maestras:{ label: 'Cat. Maestras',      description: 'Categorías maestras de productos' },
  email:              { label: 'Email',              description: 'Configuración de email/SMTP' },
  licencias:          { label: 'Licencias',          description: 'Licencias POS y ventas de licencias' },
  compras:            { label: 'Compras Web',        description: 'Panel de compras web' },
  sync:               { label: 'Sync POS',           description: 'Dashboard de sincronización POS' },
  delivery_hub:       { label: 'Delivery Hub',       description: 'Administración Delivery Hub' },
  whatsapp:           { label: 'WhatsApp',           description: 'WhatsApp Hub completo' },
  facturacion_admin:  { label: 'Facturación',        description: 'Administración de facturación' },
  configuracion:      { label: 'Configuración',      description: 'Configuración del sistema' },
};

/** Map permission key → first frontend route for that module */
export const PERMISSION_ROUTE_MAP = {
  dashboard:           '/superadmin',
  negocios:            '/superadmin/negocios',
  banners:             '/superadmin/banners',
  landing:             '/superadmin/landing-layout',
  tickets:             '/superadmin/tickets',
  categorias:          '/superadmin/categorias',
  tipos_negocio:       '/superadmin/tipos-negocio',
  categorias_maestras: '/superadmin/categorias-maestras',
  email:               '/superadmin/email',
  licencias:           '/superadmin/licencias-pos',
  compras:             '/superadmin/compras',
  sync:                '/superadmin/sync-dashboard',
  delivery_hub:        '/superadmin/delivery-hub',
  whatsapp:            '/superadmin/whatsapp',
  facturacion_admin:   '/superadmin/facturacion',
  configuracion:       '/superadmin/configuracion',
};

/**
 * God admin = no restrictions (permissions null, undefined, or empty array).
 */
export function isGodAdmin(user) {
  if (!user || user.role !== 'superadmin') return false;
  const perms = user.permissions;
  return !perms || perms.length === 0;
}

/**
 * Check if user has access to a specific module.
 * - Non-superadmin → false
 * - God admin → true
 * - Restricted admin → must have module in permissions list
 */
export function hasPermission(user, module) {
  if (!user || user.role !== 'superadmin') return false;
  if (isGodAdmin(user)) return true;
  return user.permissions.includes(module);
}

/**
 * Get the first allowed route for a restricted superadmin.
 * Returns '/superadmin' for god admins.
 */
export function getFirstAllowedRoute(user) {
  if (!user || user.role !== 'superadmin') return '/superadmin';
  if (isGodAdmin(user)) return '/superadmin';
  const firstPerm = user.permissions[0];
  return PERMISSION_ROUTE_MAP[firstPerm] || '/superadmin';
}
